import { DefaultQueryParams } from '@frontend/api-utils';
import { IoTExtendedClient } from '@frontend/iot/api';
import { IoTExtended } from '@frontend/iot/types';
import { useEffect, useState } from 'react';

import { HardwareCriticalIotsListCardProps } from './hardware-critical-iots-list-card.component';

export const useHardwareCriticalIotsListCard = (props: HardwareCriticalIotsListCardProps) => {
    const [items, setItems] = useState<IoTExtended[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        IoTExtendedClient.fetchIotsCriticalExtended({
            [DefaultQueryParams.ACCOUNT_ID]: props.accountId,
            [DefaultQueryParams.SIZE]: '20'
        })
            .then((response) => {
                if (!cancelled) {
                    setItems(response.results);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setItems([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return { items, isLoading };
};

export const getIotDisplayName = (iot: IoTExtended): string => iot.name || iot.id;
